var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 111,
    viewBox: "0 0 439 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.744 92.4759C332.501 80.4049 318.886 67.9999 302.39 67.9999V67.9999C285.644 67.9999 271.888 80.7709 260.581 93.1241C250.525 104.11 236.067 111 220 111C203.933 111 189.475 104.11 179.419 93.124C168.112 80.7709 154.247 67.9999 137.5 67.9999V67.9999C120.753 67.9999 106.888 80.7709 95.5813 93.124C85.5255 104.11 71.0673 111 55 111C24.6243 111 0 86.3757 0 56C0 25.6243 24.6243 1 55 1C71.0673 1 85.5254 7.88968 95.5812 18.8759C106.888 31.229 120.753 43.9999 137.5 43.9999V43.9999C154.247 43.9999 168.112 31.229 179.419 18.8759C189.475 7.88967 203.933 1 220 1C236.327 1 250.993 8.11432 261.066 19.4121C271.929 31.5967 285.3 43.9999 301.624 43.9999V43.9999C318.193 43.9999 331.697 31.2368 342.614 18.7741C352.696 7.26648 367.499 0 384 0C414.376 0 439 24.6243 439 55C439 85.3757 414.376 110 384 110C368.105 110 353.785 103.257 343.744 92.4759Z",
    fill: "#F7F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionIcon);
export default __webpack_public_path__ + "static/media/Union_icon.9902af69180f897679e15949bd676e76.svg";
export { ForwardRef as ReactComponent };